/** Textos do modal "Exportar Tabela" (Figma 4988:57404). */
export const EXPORT_TABLE_TITLE = "Exportar Tabela";
export const EXPORT_TABLE_SECTION_TITLE = "Selecione o formato de saída";
export const EXPORT_TABLE_XLSX_LAYOUT_TITLE = "Organização da planilha";
export const EXPORT_TABLE_CONFIRM_LABEL = "Exportar";
export const EXPORT_TABLE_CLOSE_LABEL = "Fechar";

/** Texto assistivo padrão (só para leitor de tela): o que o arquivo contém. */
export const exportTableScopeDescription = (listName: string) =>
  `A exportação considera a visualização atual de ${listName}: filtros, colunas visíveis e ordenação.`;
